
/**
 * jquery validate オプション(rules,messages)　の設定
 *
 */
(function () {

  var rul = {};
  var msg = {};
  var glp = {};
  var getMsg = window.ohValidateGetMsg; //先にjs/validation/common.jsを読み込んでおく
  // var changeBlank = window.ohValidateChangeBlank;

  // メールアドレス
  // ajaxでバリデートする場合、remoteにURLを指定
  // 現行では全角文字を半角に変換した後にバリデートを掛けているが、その部分をphpコード（validate-email）に追加実装
  rul['email'] = {
    required: true,
    maxlength: 60,
    remote: "/api/validate-email-dns",
  };
  msg['email'] = {
    required:getMsg('required5','メールアドレス'),
    maxlength:getMsg('max.string', 'メールアドレス', {'max' : '60'}),
    remote:getMsg('email_dns','メールアドレス'),
  };

  // グローバル変数に格納
  window.ohValidateRul = rul;
  window.ohValidateMsg = msg;
  window.ohValidateGlp = glp;

}());

/**
 * jquery validate バリデーション実行タイミングの設定
 *
 */
(function () {

}());
